import { brandConfig } from "config/brandConfig";

export default function Footer() {
  const year: number = new Date().getFullYear();

  const { brandName, NDD, contactPoint } = brandConfig;
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="grid">
          <div>
            <div className="brand">The TresorSafe</div>
            <p className="small" style={{ marginTop: 10 }}>
              © {year} {brandName} — {NDD}
            </p>
          </div>
          <div>
            <strong>Légal</strong>
            <ul className="small" style={{ listStyle: "none", padding: 0 }}>
              <li style={{ padding: "1vh" }}>
                <a href="/mentions-legales">Mentions légales</a>
              </li>
              <li style={{ padding: "1vh" }}>
                <a href="/politique-confidentialite">
                  Politique de confidentialité
                </a>
              </li>
              <li style={{ padding: "1vh" }}>
                <a href="/conditions-generales">Conditions générales</a>
              </li>
            </ul>
          </div>
          <div>
            <strong>Contact</strong>
            <p className="small">
              Email :{" "}
              <a href={`mailto:${contactPoint.email}`}>{contactPoint.email}</a>
              <br />
              Tél. :{" "}
              <a href={`tel:${contactPoint.telephone}`}>
                {contactPoint.telephone}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
